import { useLocation } from "react-router-dom";
import { AppRoutes } from "enums/routes.enum";
import { HeaderNavMenu, NAV_MENU_NON_LEGAL } from "../shared";

export const NavMenuNonLegal = () => {
    const { pathname } = useLocation();
    const isLostPhonePage = pathname === AppRoutes.LOST_PHONE;

    return (
        <HeaderNavMenu
            menu={NAV_MENU_NON_LEGAL}
            ulStyle={{
                background: "transparent",
                marginTop: 0,
            }}
            liStyle={{
                color: "#fff",
            }}
            landingType={isLostPhonePage ? "lost my phone" : "locate by number non legal"}
        />
    );
};
